<template>
  <div
    class="relative w-full px-4 py-2 hover:bg-blue-100"
    @mouseover="showSubmenu = true"
    @mouseleave="showSubmenu = false"
  >
    <span class="flex items-center">
      {{ $t("FUNDER_OFFERS.MANUAL_STATUS") }}
      <icon-base
        :icon="IconArrowUp"
        width="10"
        height="6"
        class="ml-2 -rotate-90 transform"
      />
    </span>
    <ul
      v-if="showSubmenu"
      class="absolute top-0 left-0 flex w-max -translate-x-full transform cursor-pointer flex-col items-start justify-start rounded-sm bg-white text-left shadow-md"
    >
      <li
        v-for="(status, index) in offerStatuses"
        :key="index"
        class="w-full px-4 py-2 hover:bg-blue-100"
        @click.prevent.stop="updateOffersStatus(index)"
      >
        {{ status }}
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";

import IconArrowUp from "@/components/icons/IconArrowUp.vue";
import { useDeals } from "@/hooks/deals";

import type { IOffer } from "@/models/funders";
import type { PropType } from "vue";

const props = defineProps({
  offer: {
    type: Object as PropType<IOffer>,
    required: true,
  },
});

const { getters, dispatch } = useStore();
const { isActiveDealSelfFunded } = useDeals();

const showSubmenu = ref(false);

const offerStatuses = computed(() => {
  const all: Record<string, string> = getters["options/offerStatuses"];

  if (!isActiveDealSelfFunded.value) {
    return all;
  }

  const filteredEntries = Object.entries(all).filter(
    (statusEntry) =>
      isActiveDealSelfFunded.value &&
      ["accepted", "declined"].includes(statusEntry[1].toLowerCase())
  );

  return Object.fromEntries(filteredEntries);
});

const updateOffersStatus = async (status: string | number) => {
  const { id } = props.offer;

  await dispatch("applications/updateOfferStatus", {
    id,
    status,
  });
};
</script>
